import { render } from "./Locations.vue?vue&type=template&id=8305260a&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"

import "./Locations.vue?vue&type=style&index=0&id=8305260a&scoped=true&lang=scss"
import "./Locations.vue?vue&type=style&index=1&id=8305260a&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8305260a"]])

export default __exports__